import { type PageContext, _ } from '@zto/zpage'
import { formatInter, formatPrice } from '@/utils/math'
import * as XLSX from "xlsx";
import {ZdsOrderDeliveryType,ZdsOrderStatus} from "@/pages/orderlist/config";
import dayjs from "dayjs";
/** 复制商品详情链接 */

const formatDesc = (title:any, sub:any) => {
  if(!title && !sub){
    return `--`
  }
  if(title && sub){
    return `${title}（${sub}）`
  }
  return title || sub
}


export function exportOut1688ExcelHandle() {
  return {
    message: false,
    api: 'none',
    onAction: async ({ app, data }: PageContext) => {
      const result = await app.request({
        api: 'tuxi.zds.order.pc.export1688Orders',
        params: {}
      })
      console.info('🚀 ~ file:_actions method:onAction line:16 ----- res', result)
      const sheetData = (result || []).map((item:any)=>{
        const distributed = (()=>{
          if(item.distributed === 0){
            return '现货'
          }
          if(item.distributed === 1){
            return '分销'
          }
          return ''
        })()
        return {
          '订单号': item.soNo,
          '商品名称': item.goodsName || '',
          '商品数量(件)': item.buyQyt || '',
          '商品规格1（如：颜色）': item.spec1 || '',
          '商品规格2（如：尺码）': item.spec2 || '',
          '收件人-姓名': item.name || '',
          '收件人-手机': item.phone || '',
          '收件人-省': item.provinceName || '',
          '收件人-市': item.cityName || '',
          '收件人-区': item.areaName || '',
          '收件人-详细地址': item.address || '',
          '收货地址（省/市/区/详细地址合并的收货地址）': item.allAddress || '',
          '买家留言': item.customerRemark || '',
          '1688商品链接/1688商品id': item.externalSkuCode || '',
          '分销or现货（默认或者填1走分销，0走现货）': distributed
        }
      })
      // 使用xlsx.js 生成excel并下载
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(sheetData)
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      XLSX.writeFile(wb, `1688_${Date.now()}.xlsx`)

      app.ui.showMessage({
        type: 'success',
        message: `导出成功！`
      })

      return false
    }
  }
}


/**
 * 批量发货操作
 */
export function batchDeliverGoodsHandle() {
  return {
    dialog: ({ app }: PageContext) => {
      return {
        width: 800,
        labelWidth: 0,
        itemSpan: 24,
        title:'批量导入发货信息',
        formItems: [
          {
            type: 'batch-deliver-goods',
            autoHeight: true,
            dynamicAttrs: ({ data }: PageContext) => {
              return { hidden: false, required: false }
            }
          },
        ]
      }
    }
  }
}

/**
 * 单个发货操作
 * @param disabled  是否禁用 （查看物流信息时，禁用操作）
 */
export function deliverGoodsHandle(disabled:boolean) {
  return {
    // api: 'tuxi.zds.order.pc.dispatch',
    title: disabled ? '物流详情' : '操作发货信息',
    dialog: ({ app }: PageContext) => {
      return {
        onShow: async ({ data }: PageContext) => {
          return {
            payload: {
              ...data,
              logisticsResList: data.logisticsResList?.length > 0 ? data.logisticsResList : [{ companyTypeCode: '', logisticsCode: '' }]
            }
          }
        },
        beforeSubmit: async ({ app, data }: PageContext) => {
          console.log('data>>>',data)
          const { orderId, logisticsResList } = data
          // if(Number.parseFloat(data.userBuyLimiter) < Number.parseFloat(data.buyLimiter)){
          //   app.ui.showMessage({
          //     type: 'error',
          //     message: `单人数量必须大于等于单笔数量`
          //   })
          //   return false
          // }
          // data.buyLimiter = Number.parseFloat(data.userBuyLimiter)
          // return { dispatch: [{ soNo, companyTypeCode, logisticsCode }] }
          const logisticsListData = logisticsResList.map((item:any)=> {
            return {
              orderId,
              logisticsCompanyCode: item.companyTypeCode,
              logisticsCompanyName: '--',
              logisticsNo:item.logisticsCode
            }
          })
          return { payload: logisticsListData }
        },
        onSubmit: async ({ payload }: any) => {
          // if (!api) {
          //   app.ui.showMessage({ type: 'warning', content: '无效操作' })
          //   return
          // }
          await app.request({ api:'api/pc/order/batchShipOrder', data: { orderShipmentList:payload } })
          app.ui.showMessage({
            type: 'success',
            message: '操作成功，数据更新可能有延时，请稍后确认生效'
          })
          app.triggerPageSearch()
        },
        width: 600,
        labelWidth: 80,
        itemSpan: 24,

        formItems: [
          {
            label: '订单编号',
            type: 'text',
            prop: 'soNo',
            dynamicAttrs: ({ data }: PageContext) => {
              return { hidden: !disabled }
            }
          },
          {
            labelWidth: 0,
            prop: 'logisticsResList',
            type: 'combo',
            autoAppendFirst: true,
            maxlength:10,
            span: 24,
            autoHeight: true,
            noOperation: disabled,
            disabled,
            comboAttrs: {
              labelWidth: 120,
              header: {
                content: ({ data }: PageContext) => {
                  const ruleIndex = data.$index + 1
                  return {
                    html: `<b class="text-title">包裹信息${ruleIndex}</b>`
                  }
                }
              },
              footer: {
                style: { paddingLeft: '110px' }
              }
            },
            dynamicAttrs: ({ data: outerData }: PageContext) => {
              return {
                items: [
                  {
                    label: '物流公司',
                    type: 'select',
                    prop: 'companyTypeCode',
                    options: 'expressCompanyOpts',
                    required: !disabled,
                    span: 24
                  },
                  {
                    label: '物流单号',
                    type: 'input',
                    prop: 'logisticsCode',
                    maxlength: 20,
                    required: !disabled,
                    trim: true,
                    span: 24,
                    dynamicAttrs: ({ data }: PageContext) => {
                      return {
                        rules: [
                          {
                            validator: (rule: any, value: string, callback: any) => {
                              const logisticsCodeRegex = /^[A-Za-z0-9]+$/;
                              if (!value) {
                                callback(new Error('请输入物流单号'));
                              }else if (!logisticsCodeRegex.test(value)) {
                                callback(new Error('物流单号格式不正确'));
                              } else {
                                callback();
                              }
                            },
                            data,
                          },
                        ]
                      }
                    },
                  }
                ]
              }
            }
          }
        ],

        actions: [
          ...(disabled ? [] : [{ name: 'submit', label: '确定' }]), { name: 'close' }
        ]
      }
    }
  }
}

export function refundDialog() {
  return {
    dialog: ({ app }: PageContext) => {
      return {
        width: 600,
        title: '操作退款',
        labelWidth: 80,
        itemSpan: 24,

        onShow: async ({ data }: PageContext) => {
          const res = await app.request({
            api: 'tuxi.zds.order.pc.returnPrice',
            params: {
              soNo: data.soNo
            }
          })
          const totalPaymentAmount = +formatPrice(res?.returnPrice, '')
          return {
            payload: {
              ...data,
              returnAmount: totalPaymentAmount,
              originalPaymentAmount: totalPaymentAmount,
              freightAmount: formatPrice(res?.freightAmount)
            }
          }
        },

        beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
          const {soNo,totalPaymentAmount,returnAmount,returnReason} = data

          await app.ui.showMessageBox({
            boxType: 'confirm',
            title: '确认退款',
            type: 'warning',
            showCancelButton: true,
            dangerouslyUseHTMLString:true,
            message: `
                        <div>订单金额：<span style="color:#e6a23c; font-size: 20px; font-weight: bold">${formatPrice(totalPaymentAmount,'')}元</span></div>
                        <div>退款金额：<span style="color:#f40; font-size: 20px; font-weight: bold">${returnAmount}元</span></div>
                        <div>退款原因：${escapeHTML(returnReason)}</div>
                    `
          })
          const payload = {
            soNo,
            totalPaymentAmount: formatInter(returnAmount),
            returnReason: escapeHTML(returnReason),
          }
          return { payload }
        },
        onSubmit: async ({ payload }: any) => {
          // if (!api) {
          //   app.ui.showMessage({ type: 'warning', content: '无效操作' })
          //   return
          // }
          await app.request({ api:'tuxi.zds.order.pc.returnOrder', data: payload })
          app.ui.showMessage({
            type: 'success',
            message: '操作成功，数据更新可能有延时，请稍后确认生效'
          })
          app.triggerPageSearch()
        },

        formItems: [
          {
            label: '退款金额',
            type: 'input-number',
            prop: 'returnAmount',
            span: 10,
            dynamicAttrs: ({ data }: PageContext) => {

              return {
                hidden:false,
                required: true,
                min: 0.01,
                max: data.originalPaymentAmount,
                precision: 2,
                disabled: ZdsOrderStatus.FINISH !== data.orderStatus
              }
            }
          },
          { labelWidth:0,
            type: 'html',
            // html: `元，将原路返回用户账户` ,
            html: ({ data }: PageContext) => {
              const freightAmountStr = data.deliveryMode === ZdsOrderDeliveryType.DROP_SHIPPING ? `（运费：${data.freightAmount}）`:''
              return `元，将原路返回用户账户${freightAmountStr}`
            },
            span: 14,
            fullWidth: true
          },
          { label: '退款原因', type: 'textarea', autoHeight: true, prop: 'returnReason', minlength:2, maxlength: 200, required: true }
          // { label: '退款原因', type: 'input', prop: 'remark', required: true }
        ],
        // actions: [
        //   {
        //     name: 'submit',
        //     label: '通过',
        //   },
        //   { name: 'close' }
        // ]
      }
    }
  }

}


/**
 * 查看详情
 */
export function getOrderDetailHandle() {
  return {
    dialog: ({ app }: PageContext) => {
      return {
        width: 1200,
        labelWidth: 0,
        title:'订单详情',
        itemSpan: 0,
        noPadding: true,
        formItems: [
          {
            label: '订单编号',
            type: 'text',
            prop: 'orderId',
          },
          {
            label: '订单创建时间',
            type: 'text',
            prop: 'createTime',
            formatter: (row: any) => {
              const date = dayjs(row.createTime)
              return date.format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '商品总价',
            type: 'text',
            prop: 'orderPrice',
          },
          {
            label: '商品折扣',
            type: 'text',
            prop: 'orderDiscount',
          },
          {
            label: '优惠券',
            type: 'text',
            prop: 'goodsDiscount',
          },
          {
            label: '',
            type: 'label',
            dynamicAttrs: ({ data }: PageContext) => {
              return {
                hidden: false,
                required: false,
                label:""
              }
            }
          },
          { type: 'html',
            html: '<div style="padding: 10px 20px; font-weigth: bold; font-size: 14px;">营收明细<div>',
            dynamicAttrs: ({ data }: PageContext) => {
              let html = ''

              html = '<div style="padding: 10px 20px; font-weigth: bold; font-size: 14px;width: 100%">共' +
                '<text style="color:red">' + data.itemList.length + '</text>件商品，实付金额' +
                '<text style="color:red"> ￥' + data.orderPrice + '</text>' +
                ' <div>'
              return {
                hidden: false,
                required: false,
                html
              }
            }
          },
          {
            label: '',
            labelWidth: 0,
            type: 'edit-table',
            prop: 'itemList',
            span: 24,
            noOperation: true,
            disabled: false,
            // maxRows: 10,
            // width: '100%',
            // required: true,
            autoHeight: true,
            columns: [
              {
                label: '商品编码',
                type: 'text',
                prop: 'goodsCode',

              },
              {
                label: '商品名称',
                type: 'text',
                prop: 'goodsName',
                dynamicAttrs: ({ data }: PageContext) => {
                  return { hidden:false }
                }
              },
              {
                label: '商品规格',
                type: 'text',
                prop: 'goodsName',
                dynamicAttrs: ({ data }: PageContext) => {
                  return { hidden:false }
                }
              },
              {
                label: '单价',
                type: 'text',
                prop: 'unitPrice',
                html: ({ data }: PageContext) => {
                  return `<span>${formatDesc(data.row.action, data.row.remark)}</span>`
                }


              },
              {
                label: '数量',
                type: 'text',
                prop: 'quantity',
                dynamicAttrs: ({ data }: PageContext) => {

                  return { hidden:false }
                }
              },
              {
                label: '优惠券抵扣',
                type: 'text',
                prop: 'couponDiscount',
                dynamicAttrs: ({ data }: PageContext) => {

                  return { hidden:false }
                }
              },
              {
                label: '商品折扣',
                type: 'text',
                prop: 'goodsDiscount',
                dynamicAttrs: ({ data }: PageContext) => {

                  return { hidden:false }
                }
              },
              {
                label: '实付金额',
                type: 'text',
                prop: 'actualAmount',
                dynamicAttrs: ({ data }: PageContext) => {

                  return { hidden:false }
                }
              },
              // {
              //   label: '操作人',
              //   type: 'html',
              //   html: ({ data }: PageContext) => {
              //     return `<span>${formatDesc(data.row.channelName, data.row.modifier)}</span>`
              //   }
              // },
              // { prop: 'payableAmount', label: '退款金额',
              //   formatter:(data: any) => {
              //     return '$1.2'
              //   },
              //   width: 100
              // },
            ],
            dynamicAttrs: ({ data }: PageContext) => {
              return { hidden:false }
            }
          },


        ],

        onShow: async ({ data }: PageContext) => {
          const payload = await app.request({
            api: '/api/pc/order/queryOrderDetail',
            params: { orderId: data.orderId }
          })

          return { payload: { ...data, ...payload } }
        },
        actions: [
          {
            label: '取消',
            name: 'close'
          }
        ]
      }
    }
  }
}



function escapeHTML(str: string) {
  const map = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    "'": '&apos;'
  };
  // @ts-ignore
  return str.replace(/[<>&"']/g, (match) => map[match]);
}








